<template>
  <b-card no-body class="tax-form-card mt-2">
    <div class="tax-section">
      <h6 class="section-label mt-0">
        <feather-icon icon="GitPullRequestIcon" size="13" class="mr-50" />Expense Allocation (Buyer vs Seller)
      </h6>

      <div class="split-rows">
        <div v-for="field in splitFields" :key="field.key" class="split-row">
          <div class="split-row-top">
            <span class="split-row-label">
              {{ field.label }}
              <span v-if="field.rate" class="split-row-rate">({{ field.rate }})</span>
            </span>

            <div class="split-row-amounts">
              <span class="split-amount-chip bg-light-primary text-primary">
                <feather-icon icon="UserIcon" size="11" class="mr-25" />Buyer
                <strong>฿ {{ formatNumber(buyerAmounts[field.key]) }}</strong>
              </span>
              <span class="split-amount-chip bg-light-info text-info">
                <feather-icon icon="UserIcon" size="11" class="mr-25" />Seller
                <strong>฿ {{ formatNumber(sellerAmounts[field.key]) }}</strong>
              </span>
            </div>
          </div>

          <div v-if="field.key === 'transferFee'" class="split-toggle-wrap">
            <div class="split-toggle-group">
              <button
                type="button"
                class="split-toggle-btn"
                :class="{ active: expenseSplit[field.key] === 0 }"
                @click="$emit('set-split', field.key, 0)"
              >
                Seller
              </button>
              <button
                type="button"
                class="split-toggle-btn"
                :class="{ active: expenseSplit[field.key] === 50 }"
                @click="$emit('set-split', field.key, 50)"
              >
                Half
              </button>
              <button
                type="button"
                class="split-toggle-btn"
                :class="{ active: expenseSplit[field.key] === 100 }"
                @click="$emit('set-split', field.key, 100)"
              >
                Buyer
              </button>
            </div>
          </div>
          <div
            v-else-if="field.key === 'sbtOrStampDuty' || field.key === 'withholdingTax' || field.key === 'commission'"
            class="split-toggle-wrap"
          >
            <div class="split-toggle-group">
              <button
                type="button"
                class="split-toggle-btn"
                :class="{ active: expenseSplit[field.key] === 0 }"
                @click="$emit('set-split', field.key, 0)"
              >
                Seller
              </button>
              <button
                type="button"
                class="split-toggle-btn"
                :class="{ active: expenseSplit[field.key] === 100 }"
                @click="$emit('set-split', field.key, 100)"
              >
                Buyer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { formatNumber } from '../format'

export default {
  components: { BCard },
  props: {
    splitFields: { type: Array, required: true },
    expenseSplit: { type: Object, required: true },
    buyerAmounts: { type: Object, required: true },
    sellerAmounts: { type: Object, required: true },
  },
  methods: {
    formatNumber,
  },
}
</script>
